import gql from 'graphql-tag';

const unarchiveAssetsMutation = gql`
    mutation ArchiveAssetsMutation($input: DeleteArchiveAssetsInput!) {
        unarchiveAssets(input: $input)
    }
`;

const unarchiveAssets = {
  mutation: unarchiveAssetsMutation,
  module: 'assets',
  buildVariables: (assetIds) => ({
    input: { assetIds }
  })
};

export default unarchiveAssets;